import client from './client';

// 公共：测评深度选项（题量 / AI 题数 / 轮数），首页 + 深度选择页消费
// 未登录走全局默认策略；登录用户若属于企业则走企业绑定的策略
export const getDepthOptions = () => client.get('/assessments/depth-options/');

export const createAssessment = (data) => client.post('/assessments/', data);
export const getAssessment = (id) => client.get(`/assessments/${id}/`);
export const getCurrentQuestion = (id, config) => client.get(`/assessments/${id}/current-question/`, config);
export const submitAnswer = (id, data) => client.post(`/assessments/${id}/answer/`, data);
export const selectManagerLevel = (id, managerLevel) =>
  client.post(`/assessments/${id}/manager-level/`, { manager_level: managerLevel });
export const createAssessmentRetest = (id) =>
  client.post(`/assessments/${id}/retests/`, {});
export const resumeAssessment = () => client.get('/assessments/resume/');
export const abandonAssessment = (id) => client.post(`/assessments/${id}/abandon/`);
export const getHistory = () => client.get('/assessments/history/');
export const getReport = (assessmentId) => client.get(`/reports/${assessmentId}/`);
export const retryReport = (assessmentId) => client.post(`/reports/${assessmentId}/`);
export const downloadReportPDF = (assessmentId) =>
  client.get(`/reports/${assessmentId}/download/`, { responseType: 'blob' });
export const getWrongAnswers = (assessmentId) =>
  client.get(`/reports/${assessmentId}/wrong-answers/`);
